const initialState = {
    "paso": 0,
    "video": false,
    "detalle": false
}

export function videosRdc(state = initialState, action) {
    
    switch (action.type) {
        case "VIDEO_PASO": 
            return {...state,
                "paso": action.paso
            };
        case "VIDEO_DETALLE": 
            return {...state,
                "detalle": action.detalle
            };
        case "VIDEO_SET_EVENT":
            return {...state,
                "evento": action.evento
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/gnp-servicios/reducer.js